/*
 * session.js — the established session the Check-In endpoint relies on.
 * IDs are resolved by the entry flow (tenant via QR/code → employee via
 * identity tap → project + confidence via Assignment). The check-in never
 * searches; it reads these already-known IDs (brief: Session Context).
 */
export const STEPS = ['entry', 'join', 'identity', 'checkin', 'confirm']

export function emptySession() {
  return {
    tenant: null,       // { id, name }
    employee: null,     // { id, name }
    project: null,      // { id, name, location } | null
    confidence: null,   // 'High' | 'Medium' | 'Low'
    assignmentId: null,
    ambiguous: false,
    projectCorrected: false, // true once the member taps "Wrong Project"
  }
}
